module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/VANITY-FAIR_S01.f0c3fad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/VANITY-FAIR_S01.jpg
// module id = fTYC
// module chunks = 0